module.exports = __webpack_public_path__ + "img/_ABS9718.cac7ef2c.jpg";